import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AnyMxRecord } from "dns";
import { IMyCalendarMonth, IMyDateModel, IMyDpOptions, IMyInputFieldChanged } from "mydatepicker";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DateService } from "src/app/date.service";
import { GlobalComponent } from "src/app/global/global.component";
import { GeneralService } from "src/app/service/general.service";
import { ClientEmployeeContactBO } from "../../client-employee-contact/client-employee-contact.model";
import { employeeOnboardEmit } from "../../employee-agreementlist/employee-agreementlist.model";

import { CommonHttpService } from "src/app/common.service"
import {
  ContactInfoLst,
  EmployeeBO,
  EmployeePayrateBO,
  functionpermission,
  GetEmployeeWagesList,
  GetEmployeeWagesLogsList,
  IsViewEdit,
  IsViewEditpayorequired,
  IsViewEditpayrate,
  payrateGridBO,
  SendToPortalBO,
  WagesSaveBo,
} from "../employee.model";
import { EmployeeService } from "../employee.service";
import { DatePipe } from "@angular/common";
import { ToastrService } from "ngx-toastr";

import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent, TextWrapSettingsModel } from "@syncfusion/ej2-angular-grids";
import { EmployeepayrateService } from "../employeepayrate.service";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import { EmployeeWagesLogsService } from "./employee-wagesLogs.service";
import { EmployeeWagesService } from "./employeeWagesList.service";

@Component({
  selector: "app-employee-wages",
  templateUrl: "./employee-wages.component.html",
  styleUrls: ["./employee-wages.component.scss"],
})


export class EmployeeWagesComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @Input() EmployeeId: string;
  @Output() IsViewEditpayrate = new EventEmitter<IsViewEditpayrate>();
  public employeeWagesdata: Observable<DataStateChangeEventArgs>;
  public employeeLogsData:Observable<DataStateChangeEventArgs>;
  @ViewChild('Wagesgrid') public Wagesgrid:GridComponent
  @ViewChild('EmpLogsgrid') public EmpLogsgrid:GridComponent
  tempayrate: EmployeePayrateBO[];
  GetEmployeeWagesBo=new GetEmployeeWagesList;
  val:any;
  EmpId: string;
  filterOptions: FilterSettingsModel;
  initialPage: object;
  EmployeewagesForm:FormGroup;
  public filterSettings: object;
  public formatOptionsYear: object;
  public formatOptionsMonth: object;
  public formatOptionsDate:object;
  public formatOptionsYearonly:object;
  public wrapSettings: TextWrapSettingsModel;
  datePickerConfig: Partial<BsDatepickerConfig>;
  EmployeeWages:WagesSaveBo = new WagesSaveBo();
  years: number[] = [];      // Array to store years
  selectedYear: number; // Default selected year
  WagesLogsList:GetEmployeeWagesLogsList = new GetEmployeeWagesLogsList()
  constructor(public global:GlobalComponent, public employeePayrateRequest:EmployeeWagesService,private employeeService:EmployeeService,
    private toastrService:ToastrService,public dateservice:DateService , public employeewagesLogsRequest:EmployeeWagesLogsService) {
    this.employeeWagesdata=this.employeePayrateRequest;
    
    console.log(this.employeeWagesdata,"employeeWagesdata-----")
    this.global.checkforlogout();
    this.datePickerConfig = Object.assign(
      {},
      {
        containerClass: "theme-dark-blue",
        dateInputFormat: "YYYY-MM",
      }
    );
     
  }
  fp:functionpermission=new functionpermission();

  ngOnInit(): void {
   this.GetEmployeeWagesBo=new GetEmployeeWagesList();
    this.formatOptionsMonth = { type: 'date', format: 'MM/yyyy' };
    this.formatOptionsYearonly={type:'date',format:'yyyy'};
    this.wrapSettings = { wrapMode: 'Content' };
    this.filterOptions = { type: 'Excel' };
    this.filterSettings = { type: 'Menu' };
    this.formatOptionsYear = { type: 'date', format: 'MM/dd/yyyy HH:mm:ss' };
    this.formatOptionsDate = { type: 'date', format: 'MM/dd/yyyy' };

    this.initialPage = { pageSizes: ['10', '20', '50', '100', '250'], pageSize: 10 };
    const currentYear = new Date().getFullYear();
    this.selectedYear=currentYear;
    this.WagesLogsList.Year=currentYear;
    this.getEmployeeWagesList();
    this.getpermission()
   
    const startYear = 2012; // Starting year
    for (let year = startYear; year <= currentYear + 18; year++) {
      this.years.push(year);
    }
    

  }

  getEmployeeWagesList(){
    this.GetEmployeeWagesBo.employeeId=this.EmployeeId;
    this.GetEmployeeWagesBo.agencyId=this.global.globalAgencyId;
    this.GetEmployeeWagesBo.logType="Employeewage";
    this.employeePayrateRequest.executewages(this.GetEmployeeWagesBo)
    this.employeeWagesdata.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      
    })
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "employee");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.employeeService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}


edittype:any;
  editWages(type,data?) {
   if(type == 'new') {
    this.edittype='new'
    this.EmployeeWages=new WagesSaveBo();
   } else {
    this.edittype='edit'
    this.EmployeeWages=data;
    this.EmployeeWages.amount=data.monthWages;
    this.EmployeeWages.empWagDate=data.empWageYear
    console.log(this.EmployeeWages);
   }
      
          
}

      setDeleteId(value) {     
        this.EmpId = value;
        
      }
      Delete(){
  
        let param = new URLSearchParams()
        param.append("MonthWageId", this.EmpId)
        param.append("EmployeeId", this.EmployeeId)
        this.employeeService.deleteWages(param).subscribe((_data: any) => {
          this.toastrService.success("Wages has been deleted successfully", "Record deleted");
          document.getElementById("openDelete").click();
           this.getEmployeeWagesList();
        },
          err => {
            console.log(err)
            this.toastrService.error(err.error);
          })
         
      }

      documentType:string=""
      public onActionComplete(G) {
        
        this.GetEmployeeWagesBo.currentpageno =
          this.Wagesgrid.pagerModule.pagerObj.currentPage;
        this.GetEmployeeWagesBo.pageitem = this.Wagesgrid.pagerModule.pagerObj.pageSize;
        // if (G.name == "actionBegin" && G.requestType == "filterbeforeopen") {
        //   this.GetEmployeeWagesBo.type = G.columnType;
        // }
        
      }
    
      public dataStateChange(state): void {       
        console.log(state,"state monthLogs");
        this.documentType = state.action.requestType.toString();
        console.log(this.documentType ,"this.documentType ")
        if (this.documentType != "filterchoicerequest") {
          if ((state.sorted || []).length) {
            this.GetEmployeeWagesBo.orderColumn = state.sorted[0].name;
            this.GetEmployeeWagesBo.orderType =
              state.sorted[0].direction === "descending" ? "DESC" : "ASC";
          }
        }
        if (
          this.documentType == "filtering" &&
          state.action.action != "clearFilter"
        ) {
          this.GetEmployeeWagesBo.field = state.action.currentFilterObject.field;
          this.GetEmployeeWagesBo.matchCase =
            state.action.currentFilterObject.matchCase;
          this.GetEmployeeWagesBo.operator = state.action.currentFilterObject.operator;
          this.GetEmployeeWagesBo.value = state.action.currentFilterObject.value;
          this.GetEmployeeWagesBo.orderColumn =
            state.action.currentFilterObject.field;
          if(this.GetEmployeeWagesBo.field =='empWageYear') {         
              this.GetEmployeeWagesBo.value = !isNaN(Date.parse(this.GetEmployeeWagesBo.value))
              ? this.global.getDateTimeString(this.GetEmployeeWagesBo.value) : null;
        
          }
          if(this.GetEmployeeWagesBo.type == 'number'){
            this.GetEmployeeWagesBo.value = (this.GetEmployeeWagesBo.value != null && this.GetEmployeeWagesBo.value != undefined)
            ? this.GetEmployeeWagesBo.value.toString() : null;
            this.GetEmployeeWagesBo.type = 'decimal';
          }
            
        }
        if ((this.documentType == "filtering" && state.action.action == "clearFilter") || ((this.GetEmployeeWagesBo.type != 'string')
          && (this.GetEmployeeWagesBo.value==null || this.GetEmployeeWagesBo.value == undefined || this.GetEmployeeWagesBo.value==''))) {
          this.GetEmployeeWagesBo.field = "employeeName";
          this.GetEmployeeWagesBo.matchCase = false;
          this.GetEmployeeWagesBo.operator = "startswith";
          this.GetEmployeeWagesBo.value = "";
          this.GetEmployeeWagesBo.orderColumn = "employeeName";
          this.GetEmployeeWagesBo.type="string";

        }
      //  if( this.GetEmployeeWagesBo.value != "" && this.GetEmployeeWagesBo.value != undefined && this.GetEmployeeWagesBo.value != null){
         this.getEmployeeWagesList();
      //  }
      }

      saveEmployeeWages(val) {
        let savevalue = JSON.parse(JSON.stringify(val));       
       
        savevalue.employeeId = this.EmployeeId;
        savevalue.agencyId = this.global.globalAgencyId;
        savevalue.empWagDate=this.global.formatEmpWagDate(this.EmployeeWages.empWagDate)
        console.log(savevalue,"Before save")
        // if (this.EmployeeWages.id == '00000000-0000-0000-0000-000000000000') {
          this.employeeService.saveEmployeeWages(savevalue).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
            document.getElementById("wagesmodelopen").click();
    
            this.toastrService.success('Wages created successfully!');
            this.getEmployeeWagesList();
            setTimeout(() => {
              this.toastrService.clear();
            }, 8000);
            
          },
            (err: any) => {
             
              this.toastrService.error(
                err,
                'Error');
            })
        // }

      }
      newdates(event, type, name) {
 
        if (type == "inputchage") {
          if( name == 'month') {
            let val = this.dateservice.inputFeildchange(event);
            if (val != undefined) {
              let val1 = this.dateservice.inputFeildchange(event);
              this.EmployeeWages.month = val1;
          }
         
        }
    
        }
        if (type == "datechagned") {
          if(name == 'month') {
            let val = this.dateservice.Datechange(event);
            if (val != undefined) {
              let val1 = this.dateservice.Datechange(event);
              this.EmployeeWages.month = val1;
            }
          }      
         
    
        }
      }
      getMonthYear(newDate) {
        if (newDate != undefined && newDate != null && newDate != "") {
          let date = this.global.getDateTimeString(newDate);
          this.EmployeeWages.empWagDate =
            new Date(date).getFullYear().toString() +
            "-" +
            (new Date(date).getMonth() + 1).toString() ;
            console.log(this.EmployeeWages,"EmployeeWages");
        }

      }
      onOpenCalendar(container) {
        console.log(container);
        container.monthSelectHandler = (event: any): void => {
          container._store.dispatch(container._actions.select(event.date));
        };
        container.setViewMode("month");
      }
    
      EmployeeLogsShow() {
        this.employeeLogsData=this.employeewagesLogsRequest;
        this.WagesLogsList.orderColumn = "createdTime";
        this.getEmployeeWagesLogsList()
      }

      getEmployeeWagesLogsList(){
        this.WagesLogsList.employeeId=this.EmployeeId;
        this.WagesLogsList.agencyId=this.global.globalAgencyId;  
        this.WagesLogsList.logType=null;      
        this.employeewagesLogsRequest.executewagesLogs(this.WagesLogsList);
        this.employeeLogsData.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
         
        })
      }

      public LogsOnActionComplete(G) {
       
        this.WagesLogsList.currentpageno =
          this.EmpLogsgrid.pagerModule.pagerObj.currentPage;
        this.WagesLogsList.pageitem = this.EmpLogsgrid.pagerModule.pagerObj.pageSize;
        // if (G.name == "actionBegin" && G.requestType == "filterbeforeopen") {
        //   this.WagesLogsList.type = G.columnType;
        // }
       
      }
    
      public LogsdataStateChang1e(state): void {
          console.log(state,"state yealy");
       
        this.documentType = state.action.requestType.toString();
        console.log(this.documentType,"documentType")
        console.log(state,"state");
        if (this.documentType != "filterchoicerequest") {
          if ((state.sorted || []).length) {
            this.WagesLogsList.orderColumn = state.sorted[0].name;
            this.WagesLogsList.orderType =
              state.sorted[0].direction === "descending" ? "DESC" : "ASC";
          }
        }
        if (
          this.documentType == "filtering" &&
          state.action.action != "clearFilter"
        ) {
          console.log("filtering if")
          this.WagesLogsList.field = state.action.currentFilterObject.field;
          this.WagesLogsList.matchCase =
            state.action.currentFilterObject.matchCase;
          this.WagesLogsList.operator = state.action.currentFilterObject.operator;
          this.WagesLogsList.value = state.action.currentFilterObject.value;
          
            if(this.WagesLogsList.field == 'empWageYear'  || this.WagesLogsList.field == 'timeSheetDate')   {
                  this.WagesLogsList.type= "datetime";                  
                  this.WagesLogsList.value = (this.WagesLogsList.value != null && this.WagesLogsList.value != "" && this.WagesLogsList.value != undefined) 
                  ? this.global.getDateTimeString(this.WagesLogsList.value) 
                  : this.WagesLogsList.value;
            }
            if(this.WagesLogsList.field == 'totalWages' || this.WagesLogsList.field == 'timesheetTotalAmount' ) {
              this.WagesLogsList.type="decimal";
              this.WagesLogsList.orderColumn =
              state.action.currentFilterObject.field;
            }
            if(this.WagesLogsList.field == 'serviceName') {
              this.WagesLogsList.type="string";
              this.WagesLogsList.orderColumn =
              state.action.currentFilterObject.field;
            }          
            this.WagesLogsList.orderType='asc';

        } else {
          if (
            this.documentType == "filtering" &&
            state.action.action == "clearFilter"
          ) {
            console.log("filtering else");
            this.WagesLogsList.field = "createdTime";
            this.WagesLogsList.matchCase = false;
            this.WagesLogsList.operator = "lessthan";
            this.WagesLogsList.value = this.global.getDateTimeString(new Date());
            this.WagesLogsList.orderColumn = "createdTime";
            this.WagesLogsList.type= "datetimeoffset";
            this.WagesLogsList.orderType='desc';

          }
        }
        this.getEmployeeWagesLogsList();
      }

      public LogsdataStateChange(state): void {
        console.log("state",state);
        this.documentType= (state.action.requestType).toString();       
          this.WagesLogsList.currentpageno = this.EmpLogsgrid.pagerModule.pagerObj.currentPage;
          this.WagesLogsList.pageitem = this.EmpLogsgrid.pagerModule.pagerObj.pageSize;   
        if (this.documentType != "filterchoicerequest") {
          if ((state.sorted || []).length) {
            this.WagesLogsList.orderColumn = state.sorted[0].name;
            this.WagesLogsList.orderType = state.sorted[0].direction === 'descending' ? 'desc' : 'asc';
          }
        }
        if (this.documentType == "filtering" && state.action.action != "clearFilter") {
         
         {
          console.log("if");
          this.WagesLogsList.field = state.action.currentFilterObject.field;
          this.WagesLogsList.matchCase =
            state.action.currentFilterObject.matchCase;
          this.WagesLogsList.operator = state.action.currentFilterObject.operator;
          this.WagesLogsList.value = state.action.currentFilterObject.value;
          this.WagesLogsList.orderColumn =
            state.action.currentFilterObject.field;
            if(this.WagesLogsList.field == 'empWageYear'  || this.WagesLogsList.field == 'timeSheetDate')   {
                  this.WagesLogsList.type= "datetime";                  
                  this.WagesLogsList.value = (this.WagesLogsList.value != null && this.WagesLogsList.value != "" && this.WagesLogsList.value != undefined) 
                  ? this.global.getDateTimeString(this.WagesLogsList.value) 
                  : this.WagesLogsList.value;
            }
            if(this.WagesLogsList.field == 'totalWages' || this.WagesLogsList.field == 'timesheetTotalAmount' ) {
              this.WagesLogsList.type="decimal";
            }
            if(this.WagesLogsList.field == 'serviceName') {
              this.WagesLogsList.type="string";
            }          
            this.WagesLogsList.orderType='asc';
        }
      }
        else {
          if (this.documentType == "filtering" && state.action.action == "clearFilter") {
            this.WagesLogsList.field = "createdTime";
            this.WagesLogsList.matchCase = false;
            this.WagesLogsList.operator = "lessthan";
            this.WagesLogsList.value = this.global.getDateTimeString(new Date());
            this.WagesLogsList.orderColumn = "createdTime";
            this.WagesLogsList.type= "datetimeoffset";
            this.WagesLogsList.orderType='desc';
          }
        }
        if (state.action.requestType != "refresh") {
            console.log(state.action.requestType,"state.action.requestType")
            this.getEmployeeWagesLogsList();
        
        }
      
      }

      onYearChange(selectedYear) {       
        this.WagesLogsList.Year=selectedYear;
          this.getEmployeeWagesLogsList();
      }
    
      
}
